'use strict';

import { useEffect, useState } from 'react';
import Select from 'react-select';
import theme from './react-select-theme.js';
import InterNACHI from '../../InterNACHI.js';

export default function Typeahead(props) {
	const {
		id,
		options,
		label = null,
		defaultValue = null,
		name = null,
		onChange = () => null,
		...select_props
	} = props;
	
	// We need to control the value of the select so that we can set it elsewhere
	const [value, setValue] = useState(defaultValue);
	
	// This allows us to programmatically set this value from outside of React
	useEffect(() => {
		if (name) {
			InterNACHI.shared.typeaheadCallbacks[name] = (search) => {
				if (Array.isArray(search)) {
					setValue(search
						.map(s => options.find(option => option.value === s))
						.filter(Boolean));
				} else {
					const found = options.find(option => option.value === search);
					if (found) {
						setValue(found);
					}
				}
			};
		}
	}, [name]);
	
	return (
		<div className="tailwind">
			{ label && (
				<label className="inline-block mb-2 text-base font-semibold cursor-pointer" htmlFor={ id }>
					{ label }
				</label>
			) }
			<Select
				inputId={ id }
				theme={ theme }
				value={ value }
				name={ name }
				options={ options }
				onChange={ (value, action) => {
					setValue(value);
					onChange(value, action);
				} }
				{ ...select_props }
			/>
		</div>
	);
}


